import { createFileRoute } from '@tanstack/react-router';
import { CalculatorsPage } from '@/components/calculators';

export const Route = createFileRoute('/_authenticated/calculators')({
  component: CalculatorsPage,
});
